import { accountConstants } from "../_constants";
import { accountService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const accountActions = {
  getEnergyDetail,
  setEnergyDetail,
  toggleTabs,
  setAlert,
  setEmail,
};

function getEnergyDetail(user) {
  return (dispatch) => {
    dispatch(request());

    accountService.getEnergyDetail(user).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountConstants.ENERGY_DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: accountConstants.ENERGY_DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountConstants.ENERGY_DETAIL_FAILURE, error };
  }
}

function setEnergyDetail(user_id, values) {
  return (dispatch) => {
    dispatch(request());

    accountService.setEnergyDetail(user_id, values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountConstants.SUBMIT_REQUEST };
  }
  function success(detail) {
    return { type: accountConstants.SUBMIT_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountConstants.SUBMIT_FAILURE, error };
  }
}

function setAlert(values) {
  return (dispatch) => {
    dispatch(request());

    accountService.setAlert(values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountConstants.SUBMIT_ALERT_REQUEST };
  }
  function success(detail) {
    return { type: accountConstants.SUBMIT_ALERT_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountConstants.SUBMIT_ALERT_FAILURE, error };
  }
}

function setEmail(values) {
  return (dispatch) => {
    dispatch(request());

    accountService.setEmail(values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountConstants.SUBMIT_EMAIL_REQUEST };
  }
  function success(detail) {
    return { type: accountConstants.SUBMIT_EMAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountConstants.SUBMIT_EMAIL_FAILURE, error };
  }
}

function toggleTabs(detail) {
  return (dispatch) => {
    dispatch(toggle(detail));
  };

  function toggle(detail) {
    return { type: accountConstants.TOGGLE_TAB, detail };
  }
}
